<template>
  <path
    d="m2.083 30.042 6.25-6.25c2.084-2.084 2.084-2.084 3.125-2.084h4.167c1.042 0 1.042 0 3.125 2.084l6.25 6.25H2.083zM25 4l-6.25 6.25c-2.083 2.083-2.083 2.083-3.125 2.083h-4.167c-1.041 0-1.041 0-3.125-2.083L2.083 4H25zM0 6.083l6.25 6.25c2.083 2.084 2.083 2.084 2.083 3.125v3.125c0 1.042 0 1.042-2.083 3.125L0 27.958V6.083z"
    fill="#E40428"
  />
</template>
